import { createSlice } from "@reduxjs/toolkit";
import {
  upgradePlan,
  initializePlans,
  selectPlanAndProceed,
  fetchPlanFeatures,
} from "./plansThunk";

const plansSlice = createSlice({
  name: "plans",
  initialState: {
    plans: [],
    loading: false,
    error: null,
    selectedPlanId: null,
    featuresByPlan: {},
  },
  reducers: {
    setPlans: (state, action) => {
      state.plans = action.payload;
    },
    clearSelection: (state) => {
      state.selectedPlanId = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // initialize plans
      .addCase(initializePlans.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(initializePlans.fulfilled, (state, action) => {
        state.loading = false;
        state.plans = action.payload;
      })
      .addCase(initializePlans.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // select and proceed
      .addCase(selectPlanAndProceed.pending, (state, action) => {
        state.loading = true;
        state.error = null;
        state.selectedPlanId = action.meta.arg;
      })
      .addCase(selectPlanAndProceed.fulfilled, (state, action) => {
        const upgradedPlanId = action.payload.planId;
        state.loading = false;
        state.selectedPlanId = upgradedPlanId;
        state.plans = state.plans.map((plan) => ({
          ...plan,
          isCurrent: plan.id === upgradedPlanId,
        }));
      })
      .addCase(selectPlanAndProceed.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // legacy upgradePlan support
      .addCase(upgradePlan.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(upgradePlan.fulfilled, (state, action) => {
        const upgradedPlanId = action.payload;
        state.loading = false;
        state.plans = state.plans.map((plan) => ({
          ...plan,
          isCurrent: plan.id === upgradedPlanId,
        }));
      })
      .addCase(upgradePlan.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // fetch features for a specific plan
      .addCase(fetchPlanFeatures.pending, (state, action) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchPlanFeatures.fulfilled, (state, action) => {
        const { planId, features } = action.payload;
        state.loading = false;
        state.featuresByPlan[planId] = features;
      })
      .addCase(fetchPlanFeatures.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { setPlans, clearSelection } = plansSlice.actions;
export default plansSlice.reducer;
